/**
 * Excel Export for Agent Portal
 * Exports flat data for a project to Excel (XLSX) file
 */

(function ($) {
  "use strict";

  $(function () {
    /**
     * Check if SheetJS is loaded
     */
    const checkSheetJS = () => {
      if (typeof XLSX === "undefined") {
        throw new Error(
          "SheetJS könyvtár nincs betöltve. Kérjük, frissítse az oldalt."
        );
      }
    };

    /**
     * Generate Excel workbook from data
     * @param {Array} data - Array of objects with flat data
     * @param {Array} headers - Array of header names
     * @returns {Blob} Excel file blob
     */
    const generateExcel = (data, headers) => {
      checkSheetJS();

      // Create a new workbook
      const wb = XLSX.utils.book_new();

      // Prepare worksheet data
      const wsData = [];

      // Add header row
      wsData.push(headers);

      // Add data rows
      data.forEach((row) => {
        const rowData = headers.map((header) => {
          const value = row[header] ?? "";
          return value;
        });
        wsData.push(rowData);
      });

      // Create worksheet from data
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // Set column widths (optional, for better readability)
      const colWidths = headers.map(() => ({ wch: 15 }));
      ws["!cols"] = colWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, "Lakások");

      // Generate Excel file
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      return new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    };

    /**
     * Trigger file download
     * @param {Blob} blob - Excel file blob
     * @param {String} filename - Download filename
     */
    const downloadExcel = (blob, filename) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };

    /**
     * Export flats to Excel
     * @param {String|Array} projectIds - Salesforce project ID(s) or residential family ID
     * @param {HTMLElement} button - Button element for feedback
     */
    const exportFlatsToExcel = async (projectIds, button) => {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = "Készítés...";

      try {
        // Check if SheetJS is loaded
        checkSheetJS();

        // Prepare params
        const ajaxParams = { action: "cordia_agent_export_flats" };
        if (Array.isArray(projectIds)) {
          ajaxParams.project_ids = JSON.stringify(projectIds);
        } else {
          ajaxParams.project_id = projectIds;
        }

        // Call via WP AJAX (session-gated proxy)
        const response = await $.ajax({
          url: localize.ajaxurl,
          method: "POST",
          data: ajaxParams,
        });

        if (!response.success) {
          throw new Error(response.data || "API hiba");
        }

        const data = response.data;

        // Validate response
        if (!Array.isArray(data) || data.length === 0) {
          throw new Error("Nincs exportálható adat ehhez a projekthez.");
        }

        // Define headers in the correct order
        const headers = [
          "Project name",
          "Apartment name",
          "Staircase",
          "Floor",
          "Number of rooms",
          "Apartment area",
          "Terrace area",
          "Garden area",
          "Orientation",
          "Facing",
          "Price",
        ];

        // Generate Excel file
        const excelBlob = generateExcel(data, headers);

        // Download file
        const projectIdStr = Array.isArray(projectIds)
          ? projectIds.join("-")
          : projectIds;
        const filename = `project-${projectIdStr}-flats.xlsx`;
        downloadExcel(excelBlob, filename);

        // Success feedback
        button.textContent = "✓ Letöltve";
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      } catch (error) {
        console.error("Excel export error:", error);

        // Error feedback
        const errorMessage =
          error.response?.data?.error ||
          error.message ||
          "Nem sikerült a letöltés. Kérjük, próbálja újra.";
        alert(errorMessage);
      } finally {
        button.disabled = false;
        if (button.textContent === "Készítés...") {
          button.textContent = originalText;
        }
      }
    };

    /**
     * Event listener for export button
     */
    $(document).on("click", ".js-download-agent-flats", function (e) {
      // Check if this button has data-project-ids or data-project attribute (Excel export button)
      let projectIds = $(this).attr("data-project-ids");

      // If data-project-ids exists, parse it as JSON array
      if (projectIds) {
        try {
          projectIds = JSON.parse(projectIds);
          if (!Array.isArray(projectIds) || projectIds.length === 0) {
            console.error("Invalid project_ids format");
            return;
          }
        } catch (err) {
          console.error("Failed to parse project_ids:", err);
          return;
        }
      } else {
        // Fallback to data-project (single family ID)
        projectIds = $(this).attr("data-project");
        if (!projectIds) {
          return; // Not an Excel export button
        }
      }

      // Prevent default and stop propagation
      e.preventDefault();
      e.stopPropagation();

      // Export to Excel
      exportFlatsToExcel(projectIds, this);
    });
  });
})(jQuery);
